// Nonce generator - to be initialized at runtime with unique values per page load
let cachedMosaicNonce = null;
let cachedCookieNonce = null;

const generateRandomNonce = () => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let nonce = '';
    for (let i = 0; i < 32; i++) {
        nonce += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return nonce;
};

// Initialize nonces - called once at app startup
exports.initializeNonces = () => {
    cachedMosaicNonce = `${generateRandomNonce()}`;
    cachedCookieNonce = `${generateRandomNonce()}`;
    return { mosaic: cachedMosaicNonce, cookie: cachedCookieNonce };
};

// Get cached nonces
exports.getMosaicNonce = () => {
    if (!cachedMosaicNonce) {
        const nonces = exports.initializeNonces();
        return nonces.mosaic;
    }
    return cachedMosaicNonce;
};

exports.getCookieNonce = () => {
    if (!cachedCookieNonce) {
        const nonces = exports.initializeNonces();
        return nonces.cookie;
    }
    return cachedCookieNonce;
};
